import FormCreate from "./FormCreate"

// L'entête (titre de carte + fil d'ariane) et la mise en page sont gérés dans FormCreate
// (titre dynamique selon prénom/nom en mode édition).
const PersonnelCreate = () => <FormCreate />

export { PersonnelCreate }
